// Pricing Vietnamese translations
export const pricingVi = {
  'add.fee.structure': 'Thêm Cấu Trúc Phí',
  'add.load.unload.fee': 'Thêm Phí Bốc Xếp',
  'add.load.unload.fee.button': 'Thêm Phí Bốc Xếp',
  'add.price': 'Thêm Giá',
  'add.rm2.fee': 'Thêm Phí RM2',
  'add.toll.fee': 'Thêm Phí Cầu Đường',
  'adding.price': 'Thêm giá',
  'additional.fees': 'Phí Bổ Sung',
  'base.price': 'Giá Cơ Bản',
  'delete.rm2.fee.confirm': 'Bạn có chắc chắn muốn xóa phí RM2 này không?',
  'districts.override.this.price': 'quận/huyện ghi đè giá này',
  'document.upload': 'Tải Tài Liệu',
  'document.upload.processing': 'Tải Lên & Xử Lý Tài Liệu',
  'download': 'Tải xuống',
  'edit.fee.structure': 'Chỉnh Sửa Cấu Trúc Phí',
  'edit.load.unload.fee': 'Chỉnh Sửa Phí Bốc Xếp',
  'edit.rm2.fee': 'Chỉnh Sửa Phí RM2',
  'edit.toll.fee': 'Chỉnh Sửa Phí Cầu Đường',
  'enter.fee.amount': 'Nhập số tiền phí',
  'enter.price.amount': 'Nhập số tiền giá',
  'error.creating.rm2.fee': 'Lỗi khi tạo phí RM2',
  'error.deleting.rm2.fee': 'Lỗi khi xóa phí RM2',
  'error.updating.rm2.fee': 'Lỗi khi cập nhật phí RM2',
  'extra.toll.fee.1': 'Phí cầu đường phụ 1',
  'extra.toll.fee.2': 'Phí cầu đường phụ 2',
  'failed.to.fetch.rm2.fees': 'Không thể tải danh sách phí RM2',
  'failed.to.load.image': 'Tải hình ảnh thất bại',
  'failed.to.load.map': 'Không thể tải bản đồ',
  'failed.to.load.positions': 'Không thể tải vị trí phương tiện',
  'fee.amount': 'Số Tiền Phí',
  'fee.must.be.greater.than.zero': 'Phí phải lớn hơn hoặc bằng 0',
  'fee.structure.history': 'Lịch Sử Cấu Trúc Phí',
  'fee.structure.management': 'Quản Lý Phí',
  'fee.type': 'Loại Phí',
  'load.unload.fee': 'Phí Bốc Xếp',
  'load.unload.fee.management': 'Quản Lý Phí Bốc Xếp',
  'loading': 'Đang tải',
  'loading.fee': 'Phí Bốc Xếp',
  'manage.fee.structure': 'Quản Lý Phí',
  'new.fee': 'Phí Mới',
  'new.price': 'Giá Mới',
  'no.price.history.available': 'Không có lịch sử giá nào',
  'no.prices.found': 'Không tìm thấy giá nào',
  'old.fee': 'Phí Cũ',
  'old.price': 'Giá Cũ',
  'optional.notes.about.rm2.fee': 'Ghi chú tùy chọn về phí RM2 này',
  'optional.reason.for.price.change': 'Lý do tùy chọn cho việc thay đổi giá',
  'overrides.province.price': 'Ghi đè giá tỉnh',
  'please.enter.fee.amount': 'Vui lòng nhập số tiền phí',
  'please.enter.valid.price': 'Vui lòng nhập giá mỗi lít hợp lệ',
  'price': 'Giá',
  'price.change': 'Thay Đổi Giá',
  'price.per.km': 'Giá Mỗi KM',
  'price.per.liter': 'Giá/Lít',
  'pricing': 'Định Giá',
  'reason.for.creating.updating.rm2.fee': 'Lý do tạo/cập nhật phí RM2 này',
  'rm2': 'RM2',
  'rm2.fee': 'Phí RM2',
  'rm2.fee.created.successfully': 'Tạo phí RM2 thành công',
  'rm2.fee.deleted.successfully': 'Xóa phí RM2 thành công',
  'rm2.fee.history': 'Lịch Sử Phí RM2',
  'rm2.fee.management': 'Quản Lý Phí RM2',
  'rm2.fee.updated.successfully': 'Cập nhật phí RM2 thành công',
  'system.fee.management': 'Quản Lý Phí Hệ Thống',
  'toll.fee': 'Phí Cầu Đường',
  'toll.fee.management': 'Quản Lý Phí Cầu Đường',
  'total.fee': 'Tổng Phí',
  'update.price': 'Cập Nhật Giá',
  'upload.more.documents': 'Tải Thêm Tài Liệu',
  'upload.new.to.replace': 'Tải tệp mới lên để thay thế ảnh hiện tại',
  'upload.pdf.or.image': 'Tải lên tệp PDF hoặc hình ảnh. Hệ thống sẽ tự động nhận diện hóa đơn xăng dầu và phiếu giao hàng.',
  'upload.process': 'Tải lên & Xử lý',
  'upload.receipt.file': 'Tải tệp hóa đơn',
  'uploading': 'Đang tải lên...',
};
